// extracted by mini-css-extract-plugin
module.exports = {"loginFormButton":"LoginPage_loginFormButton__13diS","pageBodyCenter":"LoginPage_pageBodyCenter__20112","cardContainer":"LoginPage_cardContainer__1x72I"};